import * as liquidationsList from './list';
import * as kpiLiquidationsByDays from './kpiByDays';

const reducers = {
  ...liquidationsList,
  ...kpiLiquidationsByDays,
};

export default reducers;
